import { flattenMarks } from './flattenMarks';
export var markHighlights = function (input, highlights) {
    if (!highlights) {
        return input;
    }
    var withMarks = highlights.join().match(/<mark>(.*?)<\/mark>/g) || [];
    var withoutMarks = withMarks.map(function (match) { return match.replace(/<[^>]*>/gi, ''); });
    var result = input;
    withoutMarks.forEach(function (highlight) {
        // matches ${highlight} which is not followed by `</mark>` and `>`
        // we need `>` part in cases we want to properly replace word `mark`
        var regexp = new RegExp("(" + highlight + ")(?!</mark>|>)");
        result = result.replace(regexp, "<mark>" + highlight + "</mark>");
    });
    return flattenMarks(result);
};
//# sourceMappingURL=markHighlights.js.map